import { render, staticRenderFns } from "./EstatisticasBeneficios.vue?vue&type=template&id=bf50d1d2"
import script from "./EstatisticasBeneficios.vue?vue&type=script&lang=js"
export * from "./EstatisticasBeneficios.vue?vue&type=script&lang=js"
import style0 from "./EstatisticasBeneficios.vue?vue&type=style&index=0&id=bf50d1d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports